import React, { Component } from "react";
import { connect } from "react-redux";
import { create } from "../../../../domain/auth/authActions";
import PasswordCreateForm from "../../../forms/public/PasswordCreateForm";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import styles from "./PasswordCreate.module.less";
import { Requirements } from "../PasswordForgot";
import MiniMiranda from "../../../presentational/MiniMiranda/MiniMiranda";
import track from "react-tracking";
class PasswordCreate extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div className={styles.wrapper}>
				<div className="vr vr_x4">
					<h2 className="hdg js-pageHeader">
						<FormattedMessage id="passwordCreate.header" defaultMessage="Create Password"/>
					</h2>
				</div>

				

				<StatusMessage isError isActive={this.props.authError ? true : false} error={this.props.authError ? this.props.authError : null} customMessage={StatusMessages.VALIDATION.INTRO_CREATE_ACCOUNT} domain="validation"/>

				<div className={styles.content}>
					<div>
						<div className="vr vr_x5">
							<div className="text">
								{process.env.CLIENT == null && this.props.deceased && (<FormattedMessage tagName="p" id="profileCreate.intro1" defaultMessage={"Please note: In your capacity as the person who is authorized to act on "
            + "behalf of the estate, you are not personally liable for such bills."}/>)}
								{process.env.CLIENT == null && (<MiniMiranda />)}
								<FormattedMessage id="passwordCreate.intro" defaultMessage="Select a security question & answer and create your password below." tagName="p"/>
							</div>
						</div>
						<div className="u-isVisuallyHidden">
							<FormattedMessage tagName="h2" id="passwordCreate.requirements.header" defaultMessage="Password requirements:"/>
							<Requirements />
						</div>
						<div className="vr vr_x5">
							<PasswordCreateForm createUser={this.props.create} fieldErrors={this.props.authFieldErrors} securityQuestions={this.props.securityQuestions} validationRequest={this.props.validationRequest} isLoading={this.props.authIsLoading} locale={this.props.locale}/>
						</div>
						<StatusMessage isLoad isActive={this.props.authIsLoading ? true : false}/>
					</div>
					<div aria-hidden="true">
						<div className="vr vr_x2">
							<h2 className="label">
								<FormattedMessage id="passwordCreate.requirements.header" defaultMessage="Password requirements:"/>
							</h2>
						</div>
						<div className="vr vr_x5">
							<div className="text">
								<Requirements className="listV listV_x3 mix-listV_bullet"/>
							</div>
						</div>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    authError: state.auth.error,
    authFieldErrors: state.auth.fieldErrors,
    authIsLoading: state.auth.isLoading,
    authIsSuccess: state.auth.isSuccess,
    passwordErrorMessage: state.auth.passwordError,
    securityQuestions: state.auth.questions,
    validationRequest: state.validation.validationRequest,
    locale: state.i18n.locale,
    deceased: state.validation.deceased
});
const bindActionsToProps = {
    create
};
/* Create and export container component that wraps PasswordCreate for property binding */
export default track({ page: "PasswordCreate" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(PasswordCreate));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/PasswordCreate/PasswordCreate.tsx